import { render } from "./MoneyFormat.vue?vue&type=template&id=46fb5283"
import script from "./MoneyFormat.vue?vue&type=script&lang=js"
export * from "./MoneyFormat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__